// Wire types mirroring the backend serviceDetail / metrics payloads.

export interface ICAPMetrics {
    activeConnections: number;
    maxConnections: number;
    queueDepth: number;
    queueCapacity: number;
    totalAccepted: number;
    totalRejected: number;
    resp200: number;
    resp204: number;
    peakActive: number;
    peakActiveAt?: number;
    peakQueueDepth: number;
    peakQueueAt?: number;
}

export interface ProviderHealth {
    name: string;
    enabled: boolean;
    working: boolean;
    lastOkAt?: number;
    lastError?: string;
    lastErrorAt?: number;
    sent: number;
    failed: number;
}

export interface AlertMetrics {
    cronsRunning: number;
    providers?: ProviderHealth[];
    lastCronRunAt?: number;
    nextRunAt?: number;
    alertsTriggered: number;
}

export interface ServiceMetrics {
    schemaVersion: number;
    collectedAt: number;
    startedAt?: number;
    icap?: ICAPMetrics;
    alert?: AlertMetrics;
}

export interface RedisDetail {
    reachable: boolean;
    pingMs: number;
}

export interface ServiceDetail {
    id: string;
    instanceName: string;
    kind: string;
    role: string;
    status: string;
    version?: string;
    mode?: string;
    description: string;
    rulesetVersion?: number;
    rulesetUpdatedAt?: number;
    metrics?: ServiceMetrics;
    redis?: RedisDetail;
    search?: RedisDetail;
    fetchedAt: number;
}

export interface MetricsHistoryPoint {
    timestamp: number;
    activeMax?: number;
    activeAvg?: number;
    queueMax?: number;
    maxConnections?: number;
    queueCapacity?: number;
    redisPingMs?: number;
    esPingMs?: number;
}

export interface MetricsHistory {
    instanceName: string;
    points: MetricsHistoryPoint[];
}

export interface Run {
    id: string;        // the run's KSUID
    startedAt: number; // unix seconds
    lastSeenAt: number;
}

export interface RunsResponse {
    instanceName: string;
    runs: Run[];
}

export const KIND_LABEL: Record<string, string> = {
    "shield-all": "Shield (all-in-one)",
    "shield-web": "Shield Web",
    "shield-api": "Shield API",
    "shield-icap": "Shield ICAP",
    "shield-alert": "Shield Alert",
    "redis": "Settings",
    "elasticsearch": "Activity Log",
    "opensearch": "Activity Log",
};
